// ═══════════════════════════════════════════════════════════════════
//  layout/MobileHeader.js
//  MobileHeader
// ═══════════════════════════════════════════════════════════════════

import { THEME } from "../socle/theme";

// ─── NAVIGATION MOBILE (en-tête + barre d'onglets + menu coulissant) ───
export function MobileHeader({ onMenu }) {
  return (
    <div style={{ position: "sticky", top: 0, zIndex: 40, height: 54, background: THEME.surface, borderBottom: `1px solid ${THEME.border}`, display: "flex", alignItems: "center", gap: 10, padding: "0 14px" }}>
      <button onClick={onMenu} aria-label="Menu" style={{ background: "transparent", border: "none", color: THEME.textMuted, fontSize: 24, cursor: "pointer", padding: 4, lineHeight: 1 }}>☰</button>
      <span style={{ fontSize: 18, color: THEME.gold }}>✦</span>
      <div style={{ lineHeight: 1.1 }}>
        <div style={{ color: THEME.gold, fontWeight: 800, fontSize: 15, letterSpacing: 1 }}>BOXORIA</div>
        <div style={{ color: THEME.textMuted, fontSize: 9 }}>Intranet Staff</div>
      </div>
    </div>
  );
}
